<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/gardenList' }">
					<i class="el-icon-school"></i> 绘本管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>编辑绘本开放幼儿园</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="155px">
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'绘本幼儿园'" prop="saaNAME">
							<el-select  v-model="ruleForm.saaNAME" filterable clearable disabled :placeholder="'请选择借阅方式'" class="select-shop mr10" >
								<el-option v-for="item in ruleForm.optionsSAA" :key="item.SAAMSID" :label="item.SAANAME" :value="item.SAAMSID"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>	
					
					
				<!-- 	:disabled="HbopFlag" -->
				<el-row v-if="ms_role=='1'">
					<el-col :span="12">
						<el-form-item :label="'借阅方式'" prop="saaHBOP">
							<el-select  v-model="ruleForm.saaHBOP" clearable :placeholder="'请选择借阅方式'"   @change="changeHBOP"  class="select-shop mr10" >
								<el-option v-for="item in ruleForm.optionsHbop" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'可借阅数量'" prop="saaJYSL">
							<el-input v-model="ruleForm.saaJYSL" :placeholder="'请输入可借阅数量'"  oninput="value=value.replace(/[^\d]/g,'')"    style="width: 215px;"  maxlength="3"> </el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'借阅天数'" prop="saaKJSJ">
							<el-input v-model="ruleForm.saaKJSJ" :placeholder="'请输入借阅天数'"  oninput="value=value.replace(/[^\d]/g,'')"  style="width: 215px;"  maxlength="3"> </el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'开启收费计时'" prop="saaQXKQ">
							<el-radio-group v-model="ruleForm.saaQXKQ" @change="changeQXKQ" :disabled="isRepeat">
								<el-radio label="0">不开启</el-radio>
								<el-radio label="1">开启</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'绘本归还到期提醒'" prop="saaGHTX">
							<el-radio-group v-model="ruleForm.saaGHTX" @change="changeGHTX" >
								<el-radio label="1">不提醒</el-radio>
								<el-radio label="2">自动提醒</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				
				
				<el-row v-if="show">
					<el-col :span="12">
						<el-form-item :label="'到期前'" prop="saaDQXS">
							<el-input v-model="ruleForm.saaDQXS" :placeholder="'请输入小时'"  oninput="value=value.replace(/[^\d]/g,'')"  style="width: 100px;"  maxlength="3"> </el-input>
							小时提醒家长
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button :loading="submitFormLoading" type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
			</el-form>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'editBookSAA',
		data() {
			//验证字符串
			
			const checkKJSJ = (rule, value, callback) => {
				 	if (value =="") {
				 		callback(new Error('请输入可借天数'));
				 	} else {
						if(Number(value)<=0)
						{
							callback(new Error('请录入大于或等于1的整数'));
						
						}
				 	}
					callback()
			}
			
			
			const checkJYSL = (rule, value, callback) => {
				 	if (value =="") {
				 		callback(new Error('请输入可借阅数量'));
				 	} else {
						if(Number(value)<=0)
						{
							callback(new Error('请录入大于或等于1的整数'));
						
						}
				 	}
					callback()
			}
			
			
			const checkDQXS = (rule, value, callback) => {
				 	if (value =="") {
				 		callback(new Error('请输入小时'));
				 	} else {
						if(Number(value)<=0)
						{
							callback(new Error('请录入大于或等于1的整数'));
						
						}
				 	}
					callback()
			}
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				submitFormLoading: false, // 提交按钮load效果
				disVisible: true,
				ms_role : sessionStorage.getItem("ms_role"),
				isRepeat: false,
				show:false,
				sID:'',
				HbopFlag:false,
				sTYPE:'',
				page:1,
				hbop:'',
				
				ruleForm: {
					saaHBOP:'',
					optionsHbop:[],
					saaJYSL:'',
					saaKJSJ:'',
					saaQXKQ:'',
					optionsSAA:[],
					saaSAAI:'',
					saaGHTX:'',
					saaDQXS:'',
					saaNAME:'',
					
				},
				rules: {
					saaSAAI:[{
						required: true,
						message: '请选择幼儿园', 
						trigger: ['blur', 'change'],
					}],
					saaHBOP:[{
						required: true,
						message: '请选择借阅方式', 
						trigger: ['blur', 'change'],
					}],
					saaKJSJ:[{
						required: true,
						// message: '请输入借阅天数', 
						trigger: ['blur', 'change'],
						validator: checkKJSJ
						
					}],
					saaJYSL:[{
						required: true,
						// message: '请输入可借数量', 
						trigger: ['blur', 'change'],
						validator: checkJYSL
					}],
					
					saaDQXS:[{
						required: true,
						// message: '请输入到期前小时', 
						trigger: ['blur', 'change'],
						validator: checkDQXS
					}]
				}
			};
		},
		created() {
			this.sID = this.$route.query.SAAMSID;
			// this.page = this.$route.query.page;
			this.getINI();
			this.Get_SAA_INI();
			this.Get_SAA_BYID();
		},
		methods:{
			
			getINI() {
				const self_count = this;
				var postUrl = 'WCF/Public/svcPublic.svc/Get_INI_KEY1';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sKEY1:'10021'
						})
					.then((response) => {
						
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						//console.log(resCount);
						let resKKDT = response.data.KKDT;
						//console.log(resKKDT);
						if (resCount > 0) {
							
							//渲染数据 List
							this.ruleForm.optionsHbop = resKKDT; //数据数组
						} else {
							this.ruleForm.optionsHbop = []; //数据数组
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取信息失败', //请求失败
							type: 'error'
						});
					});
			
			},
			Get_SAA_INI() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcSMA.svc/Get_SAA_INI';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon //web侧 登录邮箱
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.ruleForm.optionsSAA = response.data.KKDT;
						
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取幼儿园请求失败', //请求失败
						type: 'error'
					});
			
				});
			},
			
			
			Get_SAA_BYID() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcSMA.svc/Get_SAA_BYID';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon ,//web侧 登录邮箱
						sID:self_shop.sID
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						 this.ruleForm.saaSAAI= response.data.KKDT[0].SAAMSID;
						 this.ruleForm.saaNAME=response.data.KKDT[0].SAANAME;
						 this.ruleForm.saaHBOP= response.data.KKDT[0].SAAHBOP;
						 this.hbop= response.data.KKDT[0].SAAHBOP;
						 this.ruleForm.saaJYSL= response.data.KKDT[0].SAAJYSL;
						 this.ruleForm.saaKJSJ=response.data.KKDT[0].SAAKJSJ;
						 this.ruleForm.saaQXKQ=response.data.KKDT[0].SAAQXKQ;
						 this.sTYPE=response.data.KKDT[0].SAAQXKQ;
						 if(this.ruleForm.saaQXKQ=="1")
						 {
							 this.isRepeat=true;
						 }
						 this.ruleForm.saaGHTX=response.data.KKDT[0].SAAGHTX;
						 if (this.ruleForm.saaGHTX=='2')
						 {
							 this.show=true
						 }
						 // if (this.ruleForm.saaHBOP=="1"||this.ruleForm.saaHBOP=="2"){
							//  this.HbopFlag=true;
						 // }
						 this.ruleForm.saaDQXS=response.data.KKDT[0].SAADQXS;
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取幼儿园请求失败', //请求失败
						type: 'error'
					});
			
				});
			},
			changeHBOP(){
				if(this.ruleForm.saaHBOP!=this.hbop)
				{
					this.$confirm('修改借阅方式，会导致此幼儿园APP端业务流程发生改变，是否继续？', '提示', {
					          confirmButtonText: '确定',
					          cancelButtonText: '取消',
					          type: 'warning'
					        }).then(() => {
								
					        }).catch(() => {
					          this.ruleForm.saaHBOP=this.hbop
					        });
				}
			},
			changeQXKQ(){
				if(this.ruleForm.saaQXKQ=='1')
				{
					this.$confirm('开启收费计时后，将不能关闭，是否确认开启', '提示', {
					          confirmButtonText: '确定',
					          cancelButtonText: '取消',
					          type: 'warning'
					        }).then(() => {
								
					        }).catch(() => {
					          this.ruleForm.saaQXKQ='0'
					        });
				}
			},
			changeGHTX(){
				if(this.ruleForm.saaGHTX=='2'){
					this.show=true;
				}else{
					this.show=false;
				}
			},
			
			submitForm(formName) {
				
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.submitFormLoading = true;
						const self = this;
						var postUrl = 'WCF/WEB/svcSMA.svc/SAVE_CHANGE';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
									sHBOP:self.ruleForm.saaHBOP,
									sJYSL:self.ruleForm.saaJYSL,
									sKJSJ:self.ruleForm.saaKJSJ,
									sQXKQ:self.ruleForm.saaQXKQ,
									sSAAI:self.ruleForm.saaSAAI,
									sGHTX:self.ruleForm.saaGHTX,
									sDQXS:self.ruleForm.saaDQXS,
									sID:self.sID,
									sTYPE:self.sTYPE,
									
									
								}
							)
							.then((response) => {
								//请求成功返回的数据
								this.submitFormLoading = false;
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;
			
								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '编辑失败', //新增失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('编辑成功'); // 新增成功
										this.$router.push('/bookSAA') // 跳转路由
										// this.$router.push('/bookSAA?page='+this.page) 
										// this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件 reload			
										var indexs;
										for (let i = 0; i < this.COMM.tagsLists.length; i++) {
											if (this.COMM.tagsLists[i].name == "editBookSAA") {
												indexs = i;
												break;
											}
										}
			
										this.closeTags(indexs);
									}
								} else {
									this.$message({
										message: '编辑请求失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '编辑请求失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: '表单验证失败', //表单验证失败
							type: 'error'
						});
						this.submitFormLoading = false;
					}
				});
			},
			
			goBack() {
				// this.$router.go(-1);
					
				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "editBookSAA") {
						indexs = i;
						break;
					}
				}
			
				this.closeTags(indexs);
				this.$router.push('/bookSAA') 
			},
			
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			
			
		}
	}
</script>

<style>
</style>
